<script>
import moment from "moment";
import axios from "axios";

export default {
  name: "MyApplications",
  data() {
    return {
      moment,
      applications: [],
      applicationPaging: {
        current: 1,
        total: 0,
        size: 25
      },
      loadingApplications: false,
      selectedStatus: null,
      statuses: [
        {
          name: this.$t('dictionary.status_new'),
          value: 'NEW'
        },
        {
          name: this.$t('dictionary.status_processing'),
          value: 'PROCESSING'
        },
        {
          name: this.$t('dictionary.status_canceled'),
          value: 'CANCELED'
        },
        {
          name: this.$t('dictionary.status_candidate'),
          value: 'CANDIDATE'
        },
        {
          name: this.$t('dictionary.status_interview'),
          value: 'INTERVIEW'
        },
        {
          name: this.$t('dictionary.status_accepted'),
          value: 'ACCEPTED',
        },
      ],
      orderMap: {
        PHOTO: 0,
        BODY_PICTURE: 1,
        PASSPORT: 2,
        RESUME: 3,
        PERSONAL_DATA_SHEET: 4,
        DIPLOMA: 5,
        TRANSCRIPT: 6,
        OTHER: 7
      }
    }
  },
  methods:{
    loadApplications(){
      this.loadingApplications = true;
      var url = "nomzod/applicant?";
      if(this.$store.state.oneId.accessToken) url += `token=${this.$store.state.oneId.accessToken}`;
      if(this.selectedStatus) url += `status=${this.selectedStatus}`;
      url += `&page=${this.applicationPaging.current - 1}&size=${this.applicationPaging.size}`;
      axios.get(url)
          .then(response => {
            this.applications = response.data.content
            this.applicationPaging.total = response.data.totalElements
          })
          .catch(error => {
            var msg = this.$t("dictionary.error");
            if (error.data) msg += ": " + error.data;
            this.$message.error(msg);
            this.$router.push('/vacancy');
          })
          .finally(() => {
            this.loadingApplications = false;
          })
    },
    onApplicationPageChange(current) {
      this.applicationPaging.current = current;
      this.loadApplications();
    },
    onApplicationPageSizeChange(size) {
      this.applicationPaging.size = size;
      this.applicationPaging.current = 1;
      this.loadApplications();
    },
    indexMethod(index) {
      return (this.applicationPaging.current - 1) * this.applicationPaging.size + index + 1;
    },
    getDocType(docType){
      var str = "";
      switch(docType){
        case "PHOTO":
          str = this.$t("dictionary.image");
          break;
        case "BODY_PICTURE":
          str = `${this.$t("dictionary.image")} (${this.$t("dictionary.full_body")})`;
          break;
        case "PASSPORT":
          str = this.$t("dictionary.passport");
          break;
        case "RESUME":
          str = this.$t("dictionary.resume");
          break;
        case "PERSONAL_DATA_SHEET":
          str = this.$t("dictionary.objective");
          break;
        case "DIPLOMA":
          str = this.$t("dictionary.diploma");
          break;
        case "TRANSCRIPT":
          str = this.$t("dictionary.transcript");
          break;
        case "OTHER":
          str = this.$t("dictionary.other_docs");
          break;
      }
      return str;
    },
    sortFiles(files) {
      return files.slice().sort((a, b) => {
        const orderA = this.orderMap[a.docType] !== undefined ? this.orderMap[a.docType] : 999;
        const orderB = this.orderMap[b.docType] !== undefined ? this.orderMap[b.docType] : 999;
        return orderA - orderB;
      });
    },
    getStatusTagType(status) {
      switch (status) {
        case "NEW":
          return "warning";
        case "PROCESSING":
          return "info";
        case "CANCELED":
          return "danger";
        case "CANDIDATE":
          return "info";
        case "INTERVIEW":
          return "info";
        case "ACCEPTED":
          return "success";
        default:
          return "info";
      }
    },
    getStatusTagText(status) {
      switch (status) {
        case "NEW":
          return this.$t("dictionary.status_new");
        case "PROCESSING":
          return this.$t("dictionary.status_processing");
        case "CANCELED":
          return this.$t("dictionary.status_canceled");
        case "CANDIDATE":
          return this.$t("dictionary.status_candidate");
        case "INTERVIEW":
          return this.$t("dictionary.status_interview");
        case "ACCEPTED":
          return this.$t("dictionary.status_accepted");
        default:
          return this.$t("dictionary.status_candidate");
      }
    },
    getStatusMessage(row) {
      if (!row) return "";
      switch (row.status) {
        case "NEW":
          return `(${this.$t("dictionary.status_new_message")})`;
        case "PROCESSING":
          return this.$t("dictionary.status_processing_message");
        case "CANCELED":
          return row.comment || "";
        case "CANDIDATE":
          return row.sms || row.comment || "";
        case "INTERVIEW":
          return row.comment || "";
        case "ACCEPTED":
          return row.comment || "";
        default:
          return "";
      }
    },
    getVacancyBranchByLangCode(vacancy){
      var str;
      switch(this.$i18n.locale){
        case "uz-UZ":
          str = vacancy.branchUz;
          break;
        case "uz-CYR":
          str = vacancy.branchCyr;
          break;
        case "uz-QR":
          str = vacancy.branchKk;
          break;
        case "ru-RU":
          str = vacancy.branchRu;
          break;
        case "en-US":
          str = vacancy.branchEn;
          break;
      }
      return str;
    },
    getVacancyPositionByLangCode(vacancy){
      var str;
      switch(this.$i18n.locale){
        case "uz-UZ":
          str = vacancy.positionUz;
          break;
        case "uz-CYR":
          str = vacancy.positionCyr;
          break;
        case "uz-QR":
          str = vacancy.positionKk;
          break;
        case "ru-RU":
          str = vacancy.positionRu;
          break;
        case "en-US":
          str = vacancy.positionEn;
          break;
      }
      return str;
    },
    goVacancies() {
      this.$router.push('/vacancy');
    },
  },
  mounted() {
    this.loadApplications();
  }
};
</script>

<template>
  <div class="py-4 bg-secondary">
    <div class="profile-page">
      <section class="section-new">
        <div class="container">
          <el-row>
            <el-col :span="24">
              <div class="card card-lift shadow border-0 card-address_page mb-3">
                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                  <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                  <el-breadcrumb-item>{{$t('menu.my_applications')}}</el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>
    </div>
    <section class="section py-3">
      <div class="container">
<!--        <div style="padding-bottom: 10px; display: flex; justify-content: flex-end; align-items: center;">-->
<!--          <el-select size="small" v-model="selectedStatus" clearable :placeholder="$t('dictionary.select_status')" @change="loadApplications">-->
<!--            <el-option-->
<!--                v-for="status in statuses"-->
<!--                :key="status.value"-->
<!--                :label="status.name"-->
<!--                :value="status.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div style="margin-bottom: 10px;">
          <el-button size="small" @click="goVacancies" class="vp-btn-apps">
            <i class="el-icon-document"></i> {{ $t('menu.vacancy') }}
          </el-button>
        </div>
        <el-table
            :data="applications"
            v-loading="loadingApplications"
            border
            style="width: 100%"
            height="calc(100vh - 350px)">
          <el-table-column type="expand">
            <template v-slot="{row}">
              <div class="expand-wrap">
                <el-row :gutter="14">
                  <el-col :span="12">
                    <div class="expand-card">
                      <div class="expand-card__title">
                        <i class="el-icon-collection"></i>
                        <span>{{ $t("dictionary.selected_vacancies") }}</span>
                      </div>
                      <div class="expand-vacancy">
                        {{ getVacancyBranchByLangCode(row.vacancy) }} \ {{ getVacancyPositionByLangCode(row.vacancy) }}
                      </div>
                      <div class="expand-stats">
                        <div class="expand-stat-chip">
                          <i class="el-icon-s-data"></i>
                          <span>{{ $t("dictionary.weight") }}: <b>{{ row.weight }}</b></span>
                        </div>
                        <div class="expand-stat-chip">
                          <i class="el-icon-top"></i>
                          <span>{{ $t("dictionary.height") }}: <b>{{ row.height }}</b></span>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="expand-card">
                      <div class="expand-card__title">
                        <i class="el-icon-folder-opened"></i>
                        <span>{{ $t("dictionary.attachments") }}</span>
                      </div>
                      <div class="expand-files">
                        <a
                          v-for="(file, index) in sortFiles(row.files)"
                          :key="file.hashId"
                          :href="'/nomzod/file/download/' + file.hashId"
                          class="expand-file-link"
                        >
                          <span class="expand-file-index">{{ index + 1 }}</span>
                          <i class="el-icon-paperclip"></i>
                          <span class="expand-file-name">{{ file.name }}</span>
                          <span class="expand-file-type">({{ getDocType(file.docType) }})</span>
                        </a>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="№"
              type="index"
              width="60"
              align="center"
              :index="indexMethod">
          </el-table-column>
          <el-table-column prop="fullName" label="Ф.И.О" style="word-break: break-word; !important;"></el-table-column>
          <el-table-column prop="pin" :label="$t('dictionary.pinfl')" align="center" class="col-jshshir">
            <template v-slot="{row}">
              <div class="cell-pill cell-jshshir">
                <i class="el-icon-user"></i>
                <span class="cell-pill__text">{{ row.pin }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="pportNo" :label="$t('dictionary.passport')" align="center" class="col-passport">
            <template v-slot="{row}">
              <div class="cell-pill cell-passport">
                <i class="el-icon-document"></i>
                <span class="cell-pill__text">{{ row.pportNo }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" align="center" :label="$t('dictionary.phone')" class="col-phone">
            <template v-slot="{row}">
              <div class="cell-phone">
                <i class="el-icon-phone"></i>
                <span class="cell-phone__text">{{ row.phone }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" align="center" :label="$t('dictionary.extra_phone')" class="col-extra-phone">
            <template v-slot="{row}">
              <div class="cell-phone">
                <i class="el-icon-phone"></i>
                <span class="cell-phone__text">{{ row.extraPhone }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('dictionary.status')" align="center" class="col-status">
            <template v-slot="{row}">
              <div class="cell-status">
                <el-tag
                  :type="getStatusTagType(row.status)"
                  size="small"
                  effect="plain"
                  class="cell-status__tag"
                >
                  {{ getStatusTagText(row.status) }}
                </el-tag>
                <div class="cell-status__message" v-if="getStatusMessage(row)">
                  {{ getStatusMessage(row) }}
                </div>
                <a v-if="row.status == 'PROCESSING' && row.referralHashId" :href="'/nomzod/file/download/' + row.referralHashId"><i class="el-icon-download"/> Тиббий кўрикка йўлланма</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="dt" align="center" :label="$t('dictionary.date')" class="col-date">
            <template v-slot="{row}">
              <div class="cell-date">
                <i class="el-icon-date"></i>
                <span class="cell-date__text">{{ moment(row.birthdate).format("DD.MM.YYYY") }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex; justify-content: center; align-items: center; margin-top: 12px">
          <el-pagination
              align="center"
              background
              layout="prev, pager, next"
              @current-change="onApplicationPageChange"
              @size-change="onApplicationPageSizeChange"
              :key="applicationPaging.current"
              :current-page="applicationPaging.current"
              :page-size="applicationPaging.size"
              :total="applicationPaging.total">
          </el-pagination>
          <span style="margin-left: 16px">{{$t('app.bosh_stat')}} {{ applicationPaging.total }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.box{
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
}
.pagination{
  padding-top: 10px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-table th > .cell, ::v-deep .el-table td > .cell {
  white-space: normal !important;
  word-break: break-word;
  line-height: 1.2;
}
/* Table theme (site palette) */
::v-deep .el-table {
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
::v-deep .el-table__header-wrapper th {
  background: #f5f9ff;
  color: #1a2a44;
  font-weight: 700;
  border-bottom: 1px solid #e8eef4;
}
::v-deep .el-table__body tr > td {
  border-bottom: 1px solid #edf2f8;
}
::v-deep .el-table__body tr:hover > td {
  background: #f7fbff;
}
::v-deep .el-table td,
::v-deep .el-table th {
  padding: 10px 0;
}
::v-deep .el-tag {
  border-radius: 8px;
  font-weight: 600;
}
.cell-phone,
.cell-pill,
.cell-date {
  padding: 6px 10px;
  border-radius: 10px;
  background: rgba(57, 72, 105, 0.03);
  border: 1px solid rgba(57, 72, 105, 0.08);
}

/* Column cell visuals */
.cell-pill,
.cell-phone,
.cell-status,
.cell-date {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.cell-pill__text,
.cell-phone__text,
.cell-date__text {
  font-weight: 700;
  color: #1a2a44;
}
.cell-status__message {
  margin-top: 6px;
  font-size: 12px;
  color: #6b8ba8;
}
.cell-status {
  flex-direction: column;
}

/* Expand row design */
.expand-wrap {
  margin: 4px 10px 10px;
}
.expand-card {
  height: 100%;
  background: linear-gradient(180deg, #f9fbff 0%, #ffffff 100%);
  border: 1px solid #d9e7f3;
  border-radius: 12px;
  padding: 12px;
}
.expand-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #1a2a44;
  font-weight: 700;
  margin-bottom: 10px;
}
.expand-vacancy {
  color: #2f4d6e;
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 10px;
}
.expand-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.expand-stat-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(57, 72, 105, 0.06);
  border: 1px solid rgba(57, 72, 105, 0.1);
  color: #1a2a44;
  font-size: 13px;
}
.expand-files {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 4px;
}
.expand-file-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  border: 1px solid #dce9f4;
  border-radius: 10px;
  padding: 8px 10px;
  color: #24517f;
  transition: all 0.2s ease;
}
.expand-file-link:hover {
  background: #f3f8fe;
  border-color: #b8d2ea;
  color: #163b5d;
}
.expand-file-index {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #e8f1fb;
  color: #2c5f8a;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 20px;
}
.expand-file-name {
  font-weight: 600;
}
.expand-file-type {
  color: #6b8ba8;
  font-size: 12px;
}
</style>
